import type { CityConfig } from "../city-template/types";

export const garnerConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Garner",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "garner",
  route: "/garner",
  title: "Emergency Passport Garner, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Garner, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving southeast Raleigh and Johnston County. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Garner, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Garner and southeast Raleigh area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Garner%20North%20Carolina%20suburban%20landscape%20at%20golden%20hour%20with%20peaceful%20residential%20neighborhoods%20and%20tree-lined%20streets%2C%20southeast%20Raleigh%20corridor%20community%20atmosphere%2C%20green%20parks%20and%20well-maintained%20family%20homes%2C%20warm%20sunset%20light%20over%20Johnston%20County%20border%20area%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20vibrant%20warm%20colors%20and%20southern%20suburban%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=garner-hero-nc-001&orientation=landscape",
  heroImageAlt: "Garner North Carolina suburban landscape with peaceful residential neighborhoods and tree-lined streets at golden hour",
  geoPosition: "35.7113;-78.6142",
  geoPlacename: "Garner, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 275 miles north of Garner — about 4.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Garner", zips: "27529" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Clayton", zips: "27520, 27527" },
    { name: "Smithfield", zips: "27577" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Cary", zips: "27511, 27513, 27518, 27519" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Holly Springs", zips: "27540" },
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Wendell", zips: "27591" },
    { name: "Morrisville", zips: "27560" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Goldsboro", zips: "27530, 27531, 27533, 27534" },
    { name: "Fayetteville", zips: "28301–28312" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Garner departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southeast Raleigh Hub", desc: "Serving Garner, Clayton, and Johnston County corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/raleigh" },
    { name: "Fast passport renewal in Cary, NC", route: "/cary" },
    { name: "Emergency passport help in Clayton, NC", route: "/clayton" },
    { name: "Urgent passport services in Wake Forest, NC", route: "/wake-forest" },
    { name: "Same-day passport help in Morrisville, NC", route: "/morrisville" },
    { name: "Passport courier services in Apex, NC", route: "/apex" },
    { name: "Passport courier services in Holly Springs, NC", route: "/holly-springs" },
    { name: "Passport courier services in Fuquay-Varina, NC", route: "/fuquay-varina" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Garner remotely via secure courier. We do not have a walk-in office in Garner — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wake County and Johnston County travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of southeast Wake County and the Johnston County corridor",
  serviceAreaIntro: "From the family-friendly neighborhoods of Garner to the growing communities of Clayton, from the Raleigh city line to the Johnston County countryside, from Knightdale to Zebulon, from Wendell to Wake Forest, from Cary to Apex, from Holly Springs to Fuquay-Varina, from Morrisville to Durham, from Wilson to Rocky Mount, from Goldsboro to Fayetteville — Fast Passport Center serves the entire Garner region. We regularly help travelers from southeast Raleigh, Johnston County, and eastern North Carolina get their passports fast.",
  nearbyCitiesIntro: "We serve all Garner neighborhoods and the surrounding southeast Raleigh area including Raleigh, Clayton, Smithfield, Wake Forest, Cary, Apex, Holly Springs, Fuquay-Varina, Knightdale, Zebulon, Wendell, Morrisville, Durham, Chapel Hill, Wilson, Rocky Mount, Goldsboro, and Fayetteville. If you are anywhere in Wake, Johnston, or Wayne counties, we have you covered.",
  howItWorksIntro: "Most Garner travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Garner travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Garner and southeast Raleigh travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Garner? Here are the most common ones we hear from Wake County and Johnston County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Garner international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michelle B.",
      location: "Garner, NC",
      rating: 5,
      text: "My passport expired 4 days before our cruise to the Bahamas. Fast Passport Center had my renewal in 30 hours. I never left Garner. Their southeast Raleigh service is incredible.",
      service: "Passport Renewal",
    },
    {
      name: "James R.",
      location: "Clayton, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in Germany. Got it in 27 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Truly a lifesaver.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa H.",
      location: "Smithfield, NC",
      rating: 5,
      text: "First passport for my 8-year-old before our Disney cruise. Fast Passport Center walked us through every document. Had her passport in 5 days. So easy for Johnston County families.",
      service: "Child Passport",
    },
    {
      name: "David K.",
      location: "Raleigh, NC",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to London. Fast Passport Center had a replacement in 29 hours. Their southeast Wake coverage is the best I've found.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "garner-1",
      name: "Garner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 Timber Dr",
      city: "Garner",
      state: "NC",
      zip: "27529",
      phone: "(919) 779-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Garner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Garner facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "garner-2",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "414 E Holding Ave",
      city: "Raleigh",
      state: "NC",
      zip: "27610",
      phone: "(919) 755-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles north of Garner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Raleigh metro. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "garner-3",
      name: "Clayton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E 2nd St",
      city: "Clayton",
      state: "NC",
      zip: "27520",
      phone: "(919) 553-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles southeast of Garner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnston County and Clayton area. Less crowded than Raleigh. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "garner-4",
      name: "Cary Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 N Academy St",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Garner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service facility for Cary and Morrisville residents. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "garner-5",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "300 S Salisbury St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "8 miles north of Garner, Courthouse",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "garner-6",
      name: "Smithfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "225 E Market St",
      city: "Smithfield",
      state: "NC",
      zip: "27577",
      phone: "(919) 934-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles southeast of Garner",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnston County seat. Alternative for Garner and Johnston County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Garner photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Garner applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake and Johnston County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Garner travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Garner." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Garner address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Garner before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Garner for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Garner?", a: "Fast Passport Center offers fast passport renewal in Garner in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Garner?", a: "The nearest regional passport agency to Garner is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 275 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Garner without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Garner?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4.5 hours from Garner — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wake County and Johnston County residents." },
    { q: "Do you serve the entire Johnston County area?", a: "Absolutely. Fast Passport Center serves the entire Johnston County and southeast Wake County area including Garner, Clayton, Smithfield, Raleigh, Wake Forest, Cary, Apex, Holly Springs, Fuquay-Varina, Knightdale, Zebulon, Wendell, Morrisville, Durham, Wilson, Rocky Mount, Goldsboro, and Fayetteville. Our courier service works seamlessly from any address in the region." },
    { q: "Can I expedite a child passport in Garner?", a: "Yes. Fast Passport Center expedites child passports in Garner for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wake and Johnston County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Garner with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Garner", address: "1405 Timber Dr, Garner, NC 27529", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Garner", address: "1405 Timber Dr, Garner, NC 27529", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Garner", address: "5141 Nc 42 Hwy, Garner, NC 27529", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Raleigh", address: "3600 New Bern Ave, Raleigh, NC 27610", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Clayton", address: "11400 US-70 BUS, Clayton, NC 27520", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Cary", address: "1010 SE Cary Pkwy, Cary, NC 27518", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Smithfield", address: "1299 N Brightleaf Blvd, Smithfield, NC 27577", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Raleigh", address: "435 S Salisbury St, Raleigh, NC 27601", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Garner",
      address: "4031 Jones Sausage Rd, Garner, NC 27529",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Raleigh",
      address: "3231 Avent Ferry Rd, Raleigh, NC 27606",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Raleigh and western Wake County. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Clayton",
      address: "50 Tramway Cir, Clayton, NC 27520",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Johnston County and Clayton area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Smithfield",
      address: "215 E Main St, Smithfield, NC 27577",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Johnston County seat. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "15 miles northwest of Garner",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. American, Delta, and United hub. Only 20 minutes from Garner.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "150 miles southwest of Garner",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major alternative hub for the Charlotte metro area. Additional international routes.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "70 miles west of Garner",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Wake County Register of Deeds',
      description: 'Marriage licenses and records for Wake County. Apply in person or request certified copies.',
      url: 'https://www.wake.gov/departments-government/register-deeds',
    },
    {
      label: 'Wake County Clerk of Superior Court',
      description: 'Divorce records and decrees for Wake County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/wake-county/wake-county-clerk-of-superior-court',
    },
  ],
};